var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRoundNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0015 22C13.3066 22 14.3745 21.0769 14.3745 19.9487H9.62843C9.62843 20.4928 9.87845 21.0145 10.3235 21.3992C10.7685 21.7839 11.3721 22 12.0015 22ZM19.1205 15.8462V10.7179C19.1205 7.56923 17.1747 4.93333 13.7812 4.2359V3.53846C13.7812 2.68718 12.9863 2 12.0015 2C11.0167 2 10.2217 2.68718 10.2217 3.53846V4.2359C6.8164 4.93333 4.88238 7.55897 4.88238 10.7179V15.8462L3.35177 17.1692C2.60427 17.8154 3.12634 18.9231 4.18233 18.9231H19.8087C20.8647 18.9231 21.3987 17.8154 20.6512 17.1692L19.1205 15.8462Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 4.5,
    fill: "#FF5151",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundNotifications);
export default __webpack_public_path__ + "static/media/ic_round-notifications.9b0992557c8139242bb1b83a645ad0bf.svg";
export { ForwardRef as ReactComponent };